import { render, staticRenderFns } from "./P0195.vue?vue&type=template&id=4bd682fe&scoped=true&"
import script from "./P0195.vue?vue&type=script&lang=ts&"
export * from "./P0195.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd682fe",
  null
  
)

export default component.exports